import { scopes as tableScopes } from '../../../constants/scopes';
import { statsModes } from '../../../hooks/useAggregateStatsData';
import type { ScopeMap } from '../types';

export const insightsScopeOrder = [
  tableScopes.USER,
  tableScopes.COMPANY,
  tableScopes.GAME,
  tableScopes.SKU,
  tableScopes.KEYPROVIDER,
  tableScopes.PLATFORM,
  tableScopes.KEYWORKFLOW,
];

export function buildBaseScopes(mode: string, id?: string): ScopeMap {
  const scopes: ScopeMap = {};

  if (!id) return scopes;

  switch (mode) {
    case statsModes.COMPANY:
      scopes[tableScopes.COMPANY] = id;
      break;
    case statsModes.GAME:
      scopes[tableScopes.GAME] = id;
      break;
    case statsModes.SKU:
      scopes[tableScopes.SKU] = id;
      break;
    case statsModes.KEYPROVIDER:
      scopes[tableScopes.KEYPROVIDER] = id;
      break;
    case statsModes.PLATFORM:
      scopes[tableScopes.PLATFORM] = id;
      break;
    case statsModes.KEYWORKFLOW:
      scopes[tableScopes.KEYWORKFLOW] = id;
      break;
    case statsModes.USER:
      scopes[tableScopes.USER] = id;
      break;
    default:
      break;
  }

  return scopes;
}

export function mergeScopes(baseScopes: ScopeMap, drillScopes: ScopeMap): ScopeMap {
  return {
    ...baseScopes,
    ...drillScopes,
  };
}

export function getVisibleDrillScopeKeys(drillScopes: ScopeMap): string[] {
  return insightsScopeOrder.filter((scopeKey) => Boolean(drillScopes?.[scopeKey]));
}

export function getFallbackActiveScope(
  removedScope: string,
  drillScopes: ScopeMap
): string | undefined {
  return insightsScopeOrder.find(
    (scopeKey) => scopeKey !== removedScope && Boolean(drillScopes?.[scopeKey])
  );
}
